import { AlertTriangle, Loader2, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import WorkerPremiumCard, { WorkerPremiumCardHeader } from './WorkerPremiumCard';

export default function WorkerIncidentsCard({
  loading,
  incidents,
  formatDateTime,
  getStatusMeta,
  onReport,
  onView,
}) {
  return (
    <WorkerPremiumCard accent="amber" data-testid="worker-incidents-card">
      <WorkerPremiumCardHeader
        icon={AlertTriangle}
        title="Incidents & Concerns"
        description="Report an incident and track review status."
        action={(
          <Button size="sm" className="rounded-xl shadow-sm" onClick={onReport}>
            <Plus className="mr-1 h-4 w-4" />
            Report
          </Button>
        )}
      />
      <div>
        {loading ? (
          <div className="flex items-center justify-center py-6">
            <Loader2 className="h-5 w-5 animate-spin text-slate-500" />
          </div>
        ) : incidents.length === 0 ? (
          <p className="text-sm text-slate-600">No incidents submitted yet.</p>
        ) : (
          <div className="space-y-2">
            {incidents.slice(0, 5).map((incident) => {
              const statusMeta = getStatusMeta(incident.status);
              return (
                <div key={incident.id} className="rounded-xl border border-slate-200/80 bg-gradient-to-br from-white to-slate-50/50 p-3 shadow-sm">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <p className="font-medium text-slate-900">{incident.reference_number || incident.title}</p>
                      <p className="mt-1 text-xs text-slate-600">{formatDateTime(incident.date_occurred)} • {incident.location || 'Location not set'}</p>
                      <p className="mt-1 text-xs text-slate-600 line-clamp-2">{incident.description}</p>
                      <p className="mt-2 text-xs text-slate-700">{incident.progress_summary || 'Your report has been submitted and is awaiting review.'}</p>
                      {incident.outcome_summary ? (
                        <div className="mt-2 rounded-md border border-slate-200 bg-slate-50 p-2">
                          <p className="text-[11px] font-medium uppercase tracking-wide text-slate-500">Follow-up summary</p>
                          <p className="mt-1 text-xs text-slate-700">{incident.outcome_summary}</p>
                        </div>
                      ) : null}
                      <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-slate-500">
                        {incident.reported_at ? <span>Submitted {formatDateTime(incident.reported_at)}</span> : null}
                        {incident.reviewed_at ? <span>Reviewed {formatDateTime(incident.reviewed_at)}</span> : null}
                        {incident.closed_at ? <span>Closed {formatDateTime(incident.closed_at)}</span> : null}
                      </div>
                    </div>
                    <div className="flex shrink-0 items-center gap-2">
                      <Badge className={statusMeta.className}>
                        {incident.status_label || statusMeta.label}
                      </Badge>
                      <Button size="sm" variant="outline" onClick={() => onView(incident)}>
                        View
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </WorkerPremiumCard>
  );
}